<script setup lang="ts">
import type { Emit, Props } from '../lib/types';

import { ButtonQC } from '@qicgroupdoha/qic-connect-ds';

import { useContactsStore } from '@/entities/Stores/Contacts';
import { WhatsAppIcon } from '@/shared/ui/icons/';

defineProps<Props>();
const emit = defineEmits<Emit>();
const contactsStore = useContactsStore();

function clickHanlder() {
  emit('click');
  window.open(contactsStore.whatsAppLink, '_blank');
}
</script>

<template>
  <ButtonQC :class="{ 'btn-green': isGreen }" size="medium" variant="outline" @click="clickHanlder">
    <WhatsAppIcon />
    {{ $t('qic.help.whatsapp') }}
  </ButtonQC>
</template>

<style lang="scss" scoped>
@use 'WhatsAppButton';
</style>
